namespace Areas.ReAssigned {
    "use strict";

    //
    //CRUD functions
    //

    export function processMultipleAssign() {
        
        const newData: any = $('#ReAssignedForm').dxForm('instance').option('formData');
        var result = $('#ReAssignedForm').dxForm('instance').validate();

        if (!result.isValid) return;
        
        var dataGrid = $('#InspectionReAssignedGrid').dxDataGrid('instance');
        const dataIds = dataGrid.getSelectedRowKeys();
        if (dataIds.length === 0) {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
        else if (!newData.InspectorLk){
            DevExpress.ui.notify("Please select an inspector.", "warning", 2000);
        }
        else {
            newData.InspectionIds = dataIds;
            const data = JSON.stringify(newData);
            const url = "/Inspectors/ReAssigned/AssignMultiple";

            sendRequest(url, data, "PUT", () => { refreshData(dataGrid); });
        }
    }

    export function processNonCompliance(e) {
        var verifyVOID = window.confirm("Are you sure you would like to Process this to FTP ?");

        if (verifyVOID = true) {

            var keyId: any = $('#NonComplianceForm').dxForm('instance').option('KeyId');

            if (keyId != null) {
                var linkInfo = "/NonCompliances/Edit/ProcessFTP/" + keyId.toString() + "";

                $.ajax({
                    url: linkInfo,
                    method: "PUT",
                    contentType: "application/json",
                    data: "",
                    success: function (result) {
                        if (result.url) {
                            DevExpress.ui.notify("Process NonCompliance Completed", "info", 1000);
                            window.location.href = result.url;
                        } else {
                            DevExpress.ui.notify(result.errormsg, "error", 5000);
                        }
                    },
                    error: function (msg) {
                        DevExpress.ui.notify("Error in request: " + msg.responseText, "error", 3000);
                    }
                });

            }
        }
        else {
            DevExpress.ui.notify("Invalid Record.", "warning", 2000);
        }
    }
}
